import templateUrl from './working-on-payrolls.component.html'
import { AdpConfigService } from '../../../core/services/data-services/adp-config.service'
import { PagedEntityList, PayrollListItem, AdpImportFileDefinitionSelectResponse } from '@herbjoy/apex-api-models';
import { EventEmitter } from '../../../common/components/event-emitter';

export const WorkingOnPayrollsComponent = {
    templateUrl,
    bindings: {
        employeeID: "<employeeId",
        page: "<",
        showOnlyMyOwnWork: "<",
        onDownloadImport: "&",
        onDownloadSummary: "&",
        unassign: "&onUnassign",
        onChangePending: "&",
        onProcess: "&",
        changePage: "&onChangePage"
    },
    controllerAs: "vm",
    controller: class WorkingOnPayrollsController {
        adpConfigs: AdpImportFileDefinitionSelectResponse[];
        unassign: EventEmitter<any>;
        page: PagedEntityList<PayrollListItem>;
        payrolls: PayrollListItem[];
        totalEntityCount: number;
        pageNumber: number;
        pageSize: number;
        loaded: boolean;
        constructor(private adpConfigService: AdpConfigService) {
            'ngInject';
        }

        $onInit() {
            this.updatePageData();
            this.adpConfigService.retrieveAdpImportDefinitions()
                .then(configs => this.adpConfigs = configs)
                .finally(() => {
                    this.loaded = true;
                })
        }

        $onChanges(changesObj) {
            if (changesObj.page) {
                this.updatePageData()
            }
        }

        onUnassign($event) {
            if (confirm("You will be unassigned from this payroll. You can reassign yourself from the Unassigned tab.")) {
                this.unassign($event);
            }
        }

        updatePageData() {
            this.payrolls = this.page.Entities
            this.totalEntityCount = this.page.TotalEntityCount
            this.pageNumber = this.page.PageIndex + 1
            this.pageSize = this.page.PageSize
        }
    }
}
